function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#696E73"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50555A"
    },
    d: "M510.908,232.417L400.616,122.125c-8.598-12.3-24.536-18.073-39.517-13.125l-13.264,4.38 l-42.742-42.742c-9.012-9.384-22.934-13.326-36.113-8.974c-18.29,6.04-28.222,25.763-22.182,44.055l12.214,36.99l0,0l-50.128,16.552 l-41.291-41.291c-8.866-10.908-23.855-15.793-37.996-11.124c-18.29,6.04-28.222,25.763-22.182,44.055l12.465,37.75l-36.033,11.898 c-18.291,6.04-28.223,25.763-22.183,44.055c1.526,4.622,3.929,8.708,6.958,12.139l0,0c0.931,1.055,1.926,2.042,2.97,2.97 l74.565,74.565l-17.127,5.656c-18.291,6.04-28.223,25.763-22.183,44.055c1.69,5.115,4.449,9.576,7.949,13.217l-0.006,0.006 l113.264,113.264C237.233,511.472,246.555,512,256,512c141.385,0,256-114.615,256-256C512,248.047,511.618,240.185,510.908,232.417z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC305"
    },
    d: "M338.347,382.971l-91.549-277.253c-6.04-18.291,3.892-38.015,22.182-44.055 c18.292-6.039,38.015,3.892,44.055,22.183L404.584,361.1c6.04,18.291-3.892,38.015-22.183,44.055 C364.115,411.193,344.389,401.266,338.347,382.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DAF93"
    },
    d: "M198.963,428.154l-91.549-277.253c-6.04-18.291,3.892-38.015,22.182-44.055 c18.29-6.039,38.015,3.892,44.055,22.183L265.2,406.283c6.04,18.291-3.892,38.015-22.182,44.055 C224.723,456.376,205.003,446.443,198.963,428.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1325A"
    },
    d: "M106.846,383.987c-6.04-18.291,3.892-38.015,22.183-44.055l277.254-91.549 c18.289-6.041,38.015,3.893,44.055,22.182c6.04,18.291-3.892,38.015-22.183,44.055L150.901,406.17 C132.605,412.21,112.885,402.277,106.846,383.987z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.015,
    y: 315.069,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 -99.1262 83.4417)",
    style: {
      fill: "#1B444F"
    },
    width: 69.756,
    height: 69.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.141,
    y: 269.126,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 -77.7098 124.7412)",
    style: {
      fill: "#E64B55"
    },
    width: 69.756,
    height: 69.756
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91CDFF"
    },
    d: "M61.664,244.603c-6.04-18.291,3.892-38.015,22.183-44.055L361.101,109 c18.29-6.04,38.015,3.892,44.055,22.182c6.04,18.291-3.892,38.015-22.183,44.055l-277.254,91.55 C87.423,272.826,67.702,262.893,61.664,244.603z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.059,
    y: 175.933,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 -57.8244 62.0207)",
    style: {
      fill: "#51946F"
    },
    width: 69.756,
    height: 69.756
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.188,
    y: 130,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 -36.4108 103.3217)",
    style: {
      fill: "#82962D"
    },
    width: 69.756,
    height: 69.756
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.7fe673df.svg";
export { ForwardRef as ReactComponent };